<template lang="pug">
vm-prompt(@vm-cancel="close" @vm-accept="importAction" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="!isFile" :vm-active="isModalImportRequisitionDetailVisible" :vm-title='title')
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
      //-   input(type="file" id="file" ref="file" v-on:change="handleFileUpload()" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xls, .xlsx")
      v-uploader-file(class="table-products__uploader" only-upload acceptFiles="cvs,xls,xlsx" @drop="handleFileUpload")
      span
        slot Descarga una
        a(@click="downloadTemplateDetail()") &nbsp;plantilla de CSV de muestra
        slot &nbsp;para ver un ejemplo del formato requerido.
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { VUploaderFile } from '@/components/uploader-file'
const { mapGetters, mapActions } = createNamespacedHelpers('Requisitions')

export default {
  name: 'ModalImportRequisitionDetail',
  components: {
    VUploaderFile
  },
  props: {
    title: {
      type: String,
      default: 'Import CSV or Excel file'
    },
    model: {
      type: String,
      default: null
    },
    id: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      file: ''
    }
  },
  computed: {
    ...mapGetters([
      'isModalImportRequisitionDetailVisible'
    ]),
    isFile () {
      return !this.file
    }
  },
  methods: {
    ...mapActions([
      'importRequisitionDetail',
      'downloadTemplateDetail',
      'setModalImportRequisitionDetailVisible',
      'loadRecords'
    ]),
    handleFileUpload (file) {
      this.file = file
    },
    onUploadFile (file) {
      this.makeRecordsFromExcel({ file })
    },
    async importAction () {
      this.importRequisitionDetail({ id: this.id, file: this.file }).then(() => {
        this.loadRecords({ page: this.page })
      })
    },
    close () {
      this.setModalImportRequisitionDetailVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
a {
  cursor: pointer;
}
</style>
